export const appCdnURL = "https://w3-cdn-files.moji.com"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"},{"name":"renderer","content":"webkit"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"format-detection","content":"telephone=no"}],"link":[],"style":[{"innerHTML":"html,body{margin:0;background:#182134;color:#fff;min-height:100vh}.head-sticky{position:sticky;top:0;z-index:99;width:100%}.head-bg{position:relative;min-height:64px;background:#151b29}.wrap{width:94%;max-width:1320px;min-width:320px;padding:0 15px;margin:0 auto;box-sizing:border-box}@media (max-width:1200px){.wrap{width:100%;padding:0 32px}}"}],"script":[{"src":"https://w3-cdn-files.moji.com/early-polyfill.js","tagPosition":"head"},{"innerHTML":"(function(){var p=location.pathname;if(/^\\/(zh-CN|en-US)\\/?$/.test(p))document.documentElement.classList.add('home-rem-off');})();","type":"text/javascript","tagPosition":"head"},{"innerHTML":"(function(){try{var m=location.search.match(/[?&]compat=(\\d+)/);var s=null;var ls=null;try{ls=window.localStorage}catch(e){}if(ls){try{s=ls.getItem('moji_compat_level')}catch(e){}}var lv=m?m[1]:(s||'');if(!lv&&lv!=='0')return;window.__MOJI_COMPAT_LEVEL__=lv;var el=document.createElement('div');el.id='compat-early-boot';el.style.cssText='position:fixed;top:0;left:0;right:0;z-index:2147483647;padding:10px 12px;background:#1e3a5f;color:#fff;font:14px/1.4 sans-serif;text-align:center';el.textContent='兼容诊断 L'+lv+' 启动中…';function append(){if(document.body&&!document.getElementById('compat-early-boot'))document.body.appendChild(el);}if(document.body)append();else document.addEventListener('DOMContentLoaded',append);window.addEventListener('error',function(e){el.style.background='#7f1d1d';el.textContent='JS错误 L'+lv+': '+(e.message||'unknown').slice(0,160);});setTimeout(function(){if(el.style.display==='none')return;el.style.background='#92400e';var sys=typeof System!=='undefined'?'System有':'System无';var apis=[Array.prototype.at?'at有':'at无',Object.hasOwn?'hasOwn有':'hasOwn无'];el.textContent='L'+lv+'：Vue未挂载(>6s) '+sys+' '+apis.join(' ');var n=document.getElementById('__nuxt');if(n&&!(n.innerText||'').trim())el.textContent+=' | #__nuxt无文字';},6000);}catch(e){}})();","type":"text/javascript","tagPosition":"bodyOpen"},{"innerHTML":"window._AMapSecurityConfig = { securityJsCode: '91f1c274813b8bef5105d27150f64d94' };","type":"text/javascript","ssr":false,"body":true}],"noscript":[],"title":"墨迹官网"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true